const layerStyles = {}

export default layerStyles
